const RenderAccountActiveCell = ({ value }) => {
  if (value) {
    return 'Active'
  }
  return 'Deactivated'
}

export default RenderAccountActiveCell
